"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReviewDeckOptionsWrapper = function ReviewDeckOptionsWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "selected", _descriptor, _this);
      _initializerDefineProperty(_this, "filteredCardCount", _descriptor2, _this);
      // also in interjection_card_wrapper.js
      _initializerDefineProperty(_this, "retiredCount", _descriptor3, _this);
      _initializerDefineProperty(_this, "pastDueCount", _descriptor4, _this);
      _initializerDefineProperty(_this, "caughtUpCount", _descriptor5, _this);
      _initializerDefineProperty(_this, "hideDailyGoalMessage", _descriptor6, _this);
      _initializerDefineProperty(_this, "showDeckUpdatedMessage", _descriptor7, _this);
      _this.onCloseDailyGoalMessage = function () {
        _this.hideDailyGoalMessage = true;
        _state.AppUI.designateUiElementAsSeen('dailyGoalReviewAlert');
      };
      _this.onAfterUpdateDeck = function () {
        var _this$props$onToggleE, _this$props;
        _this.showDeckUpdatedMessage = true;
        setTimeout(function () {
          return _this.showDeckUpdatedMessage = false;
        }, 3000);
        (_this$props$onToggleE = (_this$props = _this.props).onToggleEdit) === null || _this$props$onToggleE === void 0 || _this$props$onToggleE.call(_this$props);
      };
      _this.selectedOrDeck = function (key) {
        if (key in _this.selected) {
          return _this.selected[key];
        } else {
          return _this.props.deck[(0, _utils.toCamelCase)("reviews_filter_".concat(key))];
        }
      };
      _this.gotoReviewIndex = function (deckId, type) {
        var data = {
          reviewsFilterDeckId: deckId,
          reviewsFilterCardTypeId: null,
          reviewsFilterRetired: type === 'retired',
          reviewsFilterDue: type === 'retired' ? null : type
        };
        _this.updateUser(data);
      };
      _this.updateUser = function (data) {
        (0, _lodash.each)((0, _lodash.keys)(data), function (key) {
          _state.AppUI.user.set(key, data[key]);
        });
        _state.AppUI.authUserStore.update({
          data: data
        }, _this.routeToReviewsIndex);
      };
      _this.routeToReviewsIndex = function () {
        if (_state.AppUI.layout.isNative) {} else {
          _state.AppUI.routeStore.routeToNamed('reviews.index');
        }
      };
      _this.onSetFilter = function (key, value) {
        if (value === 'RANGE[,]') {
          value = null;
        }
        _this.selected[key] = value;
        _this.getCardsCount();
      };
      _this.onSetCardTypeId = function (val) {
        var ary = (0, _utils.isPresent)(_this.cardTypeId) ? _this.cardTypeId.split(',') : [];
        if ((0, _lodash.isEmpty)(val)) {
          ary = [];
        } else if (ary.includes(val)) {
          ary = ary.filter(function (item) {
            return item !== val;
          });
        } else {
          ary.push(val);
        }
        _this.onSetFilter('card_type_id', ary.join(','));
      };
      _this.onSetCreatedFilter = function (value, key) {
        if ((0, _utils.isBlank)(key)) {
          key = 'created_at_days_ago';
        }
        _this.onSetFilter(key, value);
      };
      _this.onNativeCreatedRowChange = function (val) {
        if ((0, _utils.isBlank)(val)) {
          _this.onSetFilter('created_at_days_ago', null);
          _this.onSetFilter('created_at_before_after', null);
          return;
        }
        var _String$split = String(val).split(':'),
          _String$split2 = _slicedToArray(_String$split, 2),
          mode = _String$split2[0],
          daysPart = _String$split2[1];
        var days = parseInt(daysPart, 10);
        _this.onSetFilter('created_at_before_after', mode === 'before' ? 'before' : 'after');
        _this.onSetFilter('created_at_days_ago', days);
      };
      _this.afterGetCardsCount = function (resp) {
        _this.filteredCardCount = resp.count;
        _this.pastDueCount = resp.pastDueCount;
        _this.retiredCount = resp.retiredCount;
        _this.caughtUpCount = resp.reviewCardsCount - resp.pastDueCount - resp.retiredCount;
      };
      _this.initialize = function () {
        if (!_state.AppUI.cardTypeStore.hasIndexData) {
          _state.AppUI.cardTypeStore.getIndex({
            filters: {
              allow_reviews: true
            },
            sort: 'position'
          });
        }
        _this.getCardsCount();
      };
      _this.getCardsCount = function () {
        _this.filteredCardCount = null;
        var filters = {
          card_type_id: _this.cardTypeId,
          retired: _this.retired,
          difficulty_label: _this.difficultyLabel,
          created_at_before_after: _this.createdAtBeforeAfter,
          created_at_days_ago: _this.createdAtDaysAgo,
          due: _this.due,
          sort: _this.sort
        };
        _state.AppUI.deckStore.cardsCount({
          ids: {
            deckId: _this.props.deck.id
          },
          data: {
            filters: filters
          }
        }, _this.afterGetCardsCount);
      };
      _this.onToggleExpandOptions = function () {
        _this.expandOptions = !_this.expandOptions;
      };
      _this.onOpenDeck = function () {
        if (!_this.enabledOpenDeck) {
          return;
        }
        _state.AppUI.routeStore.routeToNamed('reviews.decks.show', {
          deckId: _this.props.deck.id
        });
      };
      _this.onChangeDifficultyLabel = function (difficultyLabel) {
        _this.onSetFilter('difficulty_label', difficultyLabel);
      };
      _this.onChangeSort = function (sort) {
        _this.selected['sort'] = sort || null;
        _state.AppUI.deckStore.update({
          ids: {
            deckId: _this.props.deck.id
          },
          data: {
            reviewsFilterSort: _this.sort
          }
        }, function () {
          if (_this.props.deck) {
            _this.props.deck.reviewsFilterSort = _this.sort;
          }
        });
      };
      _this.onClickStatus = function (status) {
        if (status === _this.due) {
          return;
        }
        if (status === 'past-due') {
          _this.onSetFilter('due', 'past-due');
        } else if (status === 'caught-up') {
          _this.onSetFilter('due', 'caught-up');
        } else if (status === 'retired') {
          _this.onSetFilter('due', 'retired');
        }
      };
      _this.closeStatusAlert = function (statusAlert) {
        if (statusAlert === 'retired') {
          _state.AppUI.designateUiElementAsSeen('reviews-retired');
        } else if (statusAlert === 'caught-up') {
          _state.AppUI.designateUiElementAsSeen('reviews-caught-up');
        }
      };
      setTimeout(_this.initialize, 200);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "showStatusAlert",
      get: function get() {
        if (this.due === 'caught-up' && !_state.AppUI.wasUiElementSeen('reviews-caught-up')) {
          return 'caught-up';
        } else if (this.due === 'retired' && !_state.AppUI.wasUiElementSeen('reviews-retired')) {
          return 'retired';
        }
      }
    }, {
      key: "showDailyGoalMessage",
      get: function get() {
        return !this.hideDailyGoalMessage && !_state.AppUI.wasUiElementSeen('dailyGoalReviewAlert') && !this.props.deck.useDailyGoal && this.props.deck.pastDueCount > 100 && !this.props.deck.archived;
      }
    }, {
      key: "showTimeZoneAlert",
      get: function get() {
        return _state.AppUI.userIsLoaded && (0, _utils.isBlank)(_state.AppUI.user.timeZone);
      }
    }, {
      key: "enabledOpenDeck",
      get: function get() {
        return this.cardsCount > 0;
      }
    }, {
      key: "cardTypeId",
      get: function get() {
        return this.selectedOrDeck('card_type_id');
      }
    }, {
      key: "retired",
      get: function get() {
        return this.due === 'retired';
      }
    }, {
      key: "difficultyLabel",
      get: function get() {
        return this.selectedOrDeck('difficulty_label');
      }
    }, {
      key: "createdAtBeforeAfter",
      get: function get() {
        return this.selectedOrDeck('created_at_before_after');
      }
    }, {
      key: "createdAtDaysAgo",
      get: function get() {
        return this.selectedOrDeck('created_at_days_ago');
      }
    }, {
      key: "due",
      get: function get() {
        return this.selectedOrDeck('due');
      }
    }, {
      key: "sort",
      get: function get() {
        var sort = this.selectedOrDeck('sort');
        if (sort === 'review_after') {
          return 'random';
        }
        return sort || 'random';
      }
    }, {
      key: "cardsCount",
      get: function get() {
        if (this.needsFilteredCardCount) {
          return this.filteredCardCount;
        } else if (this.due === 'past-due') {
          return this.pastDueCount;
        } else if (this.due === 'caught-up') {
          return this.caughtUpCount;
        } else if (this.due === 'retired') {
          return this.retiredCount;
        }
      }
    }, {
      key: "cardsText",
      get: function get() {
        if (this.due === 'past-due') {
          return 'Past Due';
        } else if (this.due === 'caught-up') {
          return 'Caught Up';
        } else if (this.due === 'retired') {
          return 'Retired';
        }
      }
    }, {
      key: "cardsCountMessage",
      get: function get() {
        var cardsDescription = (0, _utils.isPresent)(this.cardsText) ? "".concat(this.cardsText, " Cards") : 'Cards';
        return "".concat((0, _utils.formatNumber)(this.cardsCount), " ").concat(cardsDescription, " Match these Filters");
      }
    }, {
      key: "cardTypeOptions",
      get: function get() {
        var _AppUI$cardTypeStore$;
        return (_AppUI$cardTypeStore$ = _state.AppUI.cardTypeStore.indexData) === null || _AppUI$cardTypeStore$ === void 0 ? void 0 : _AppUI$cardTypeStore$.map(function (item) {
          return [item.id, item.name];
        });
      }
    }, {
      key: "cardTypeString",
      get: function get() {
        var _this$cardTypeId$spli;
        var fullString = (0, _utils.isPresent)(this.cardTypeId) ? (_this$cardTypeId$spli = this.cardTypeId.split(',')) === null || _this$cardTypeId$spli === void 0 || (_this$cardTypeId$spli = _this$cardTypeId$spli.map(function (cardTypeId) {
          var _AppUI$cardTypeStore$2;
          return (_AppUI$cardTypeStore$2 = _state.AppUI.cardTypeStore.indexData.find(function (item) {
            return item.id === cardTypeId;
          })) === null || _AppUI$cardTypeStore$2 === void 0 ? void 0 : _AppUI$cardTypeStore$2.name;
        })) === null || _this$cardTypeId$spli === void 0 ? void 0 : _this$cardTypeId$spli.join(', ') : null;
        var maxLength = 75;
        return (0, _utils.isPresent)(fullString) && _state.AppUI.cardTypeStore.hasIndexData ? "Card Types: ".concat(fullString.length > maxLength ? "".concat(fullString.substring(0, maxLength), "...") : fullString) : null;
      }
    }, {
      key: "createdAtString",
      get: function get() {
        if ((0, _utils.isPresent)(this.createdAtDaysAgo) && this.createdAtBeforeAfter === 'before') {
          return "Created Before ".concat(this.createdAtDaysAgo, " Days Ago");
        } else if ((0, _utils.isPresent)(this.createdAtDaysAgo)) {
          return "Created Last ".concat(this.createdAtDaysAgo, " Days");
        }
      }
    }, {
      key: "difficultyLabelString",
      get: function get() {
        var _this2 = this;
        return (0, _utils.isPresent)(this.difficultyLabel) ? _constants.Constants.DIFFICULTY_LABEL_OPTIONS.find(function (item) {
          return item[0] === _this2.difficultyLabel;
        })[1] : null;
      }
    }, {
      key: "hasAdvancedFilterSelected",
      get: function get() {
        return (0, _utils.isPresent)(this.cardTypeId) || (0, _utils.isPresent)(this.createdAtDaysAgo) || this.sort !== 'random';
      }
    }, {
      key: "needsFilteredCardCount",
      get: function get() {
        return (0, _utils.isPresent)(this.cardTypeId) || (0, _utils.isPresent)(this.createdAtDaysAgo);
      }
    }, {
      key: "sortOptions",
      get: function get() {
        return [['easiest', 'By Easiest'], ['most-due', 'By Most Due'], ['hardest', 'By Hardest']];
      }
    }, {
      key: "sortString",
      get: function get() {
        var _this3 = this;
        var option = this.sortOptions.find(function (item) {
          return item[0] === _this3.sort;
        });
        return this.sort !== 'random' && (0, _utils.isPresent)(option) ? "Sort ".concat(option[1]) : null;
      }
    }, {
      key: "nativeCreatedFilterValue",
      get: function get() {
        if (!(0, _utils.isPresent)(this.createdAtDaysAgo)) {
          return null;
        }
        var mode = this.createdAtBeforeAfter === 'before' ? 'before' : 'after';
        return "".concat(mode, ":").concat(this.createdAtDaysAgo);
      }
    }, {
      key: "nativeCreatedFilterOptions",
      get: function get() {
        return [['after:1', 'Last Day'], ['after:7', 'Last 7 Days'], ['after:30', 'Last 30 Days'], ['after:90', 'Last 90 Days'], ['before:1', 'Before 1 Day Ago'], ['before:7', 'Before 7 Days Ago'], ['before:30', 'Before 30 Days Ago'], ['before:90', 'Before 90 Days Ago']];
      }
    }, {
      key: "filterSettings",
      get: function get() {
        return [{
          name: 'Review Types',
          type: 'InPlaceSelect',
          options: [['past-due', 'Past Due'], ['caught-up', 'Caught Up'], ['retired', 'Retired']],
          value: this.due,
          onChange: this.onClickStatus,
          placeholder: 'All Review Types',
          webOnly: true
        }, {
          name: 'Sort',
          type: 'InPlaceSelect',
          options: this.sortOptions,
          value: this.sort === 'random' ? '' : this.sort,
          onChange: this.onChangeSort,
          tagDisplay: this.sortString,
          placeholder: 'Random'
        }, {
          name: 'Card Types',
          type: 'MultiSelect',
          options: this.cardTypeOptions,
          value: this.cardTypeId,
          onChange: this.onSetCardTypeId,
          placeholder: 'All Card Types',
          tagDisplay: this.cardTypeString,
          maxOptions: 3
        }, {
          name: 'Created',
          type: 'CreatedAt',
          value: {
            createdAtBeforeAfter: this.createdAtBeforeAfter,
            createdAtDaysAgo: this.createdAtDaysAgo
          },
          onChange: this.onSetCreatedFilter,
          placeholder: 'All Card Types',
          tagDisplay: this.createdAtString,
          webOnly: true
        }, {
          name: 'Created',
          type: 'InPlaceSelect',
          value: this.nativeCreatedFilterValue,
          options: this.nativeCreatedFilterOptions,
          onChange: this.onNativeCreatedRowChange,
          placeholder: 'Any',
          tagDisplay: this.createdAtString,
          nativeOnly: true
        }];
      }
    }, {
      key: "webFilterSettings",
      get: function get() {
        return this.filterSettings.filter(function (item) {
          return !item['nativeOnly'];
        });
      }
    }, {
      key: "nativeFilterSettings",
      get: function get() {
        return this.filterSettings.filter(function (item) {
          return !item['webOnly'];
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          cardTypeId: this.cardTypeId,
          onSetFilter: this.onSetFilter,
          cardTypeOptions: this.cardTypeOptions,
          cardsCount: this.cardsCount,
          enabledOpenDeck: this.enabledOpenDeck,
          onOpenDeck: this.onOpenDeck,
          retired: this.retired,
          due: this.due,
          gotoReviewIndex: this.gotoReviewIndex,
          onClickStatus: this.onClickStatus,
          cardsCountMessage: this.cardsCountMessage,
          showStatusAlert: this.showStatusAlert,
          closeStatusAlert: this.closeStatusAlert,
          retiredCount: this.retiredCount,
          pastDueCount: this.pastDueCount,
          caughtUpCount: this.caughtUpCount,
          webFilterSettings: this.webFilterSettings,
          nativeFilterSettings: this.nativeFilterSettings,
          showDailyGoalMessage: this.showDailyGoalMessage,
          showTimeZoneAlert: this.showTimeZoneAlert,
          onCloseDailyGoalMessage: this.onCloseDailyGoalMessage,
          showDeckUpdatedMessage: this.showDeckUpdatedMessage,
          onAfterUpdateDeck: this.onAfterUpdateDeck
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "filteredCardCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "retiredCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "pastDueCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "caughtUpCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "hideDailyGoalMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "showDeckUpdatedMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "showStatusAlert", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showStatusAlert"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showDailyGoalMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showDailyGoalMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showTimeZoneAlert", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showTimeZoneAlert"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "enabledOpenDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "enabledOpenDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "retired", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "retired"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "difficultyLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "difficultyLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdAtBeforeAfter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "createdAtBeforeAfter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdAtDaysAgo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "createdAtDaysAgo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "due", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "due"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardsCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardsText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardsText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardsCountMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardsCountMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdAtString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "createdAtString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "difficultyLabelString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "difficultyLabelString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasAdvancedFilterSelected", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasAdvancedFilterSelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "needsFilteredCardCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "needsFilteredCardCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sortOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sortOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sortString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sortString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nativeCreatedFilterValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "nativeCreatedFilterValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nativeCreatedFilterOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "nativeCreatedFilterOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "webFilterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "webFilterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nativeFilterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "nativeFilterSettings"), _class2.prototype), _class2)) || _class;
};
ReviewDeckOptionsWrapper.displayName = 'ReviewDeckOptionsWrapper';
var _default = exports["default"] = ReviewDeckOptionsWrapper;